/*
 * Copyright (c) 2022 automata-network/tgb-donation authors and contributors.
 * This software may be modified and distributed under the terms of MIT license.
 * Refer to the LICENSE file for details.
 */
import styled, { css } from 'styled-components'

import { pxToVw } from 'src/functions/units'

import { ReactComponent as CaretRightCircle } from '../../assets/iconset/caret-right-circle.svg'
import { ReactComponent as CaretRight } from '../../assets/iconset/caret-right.svg'
import { ReactComponent as Close } from '../../assets/iconset/close.svg'
import { ReactComponent as Copy } from '../../assets/iconset/copy.svg'
import { ReactComponent as Coupon } from '../../assets/iconset/coupon.svg'
import { ReactComponent as CurrencyDollar } from '../../assets/iconset/currency-dollar.svg'
import { ReactComponent as Day } from '../../assets/iconset/day.svg'
import { ReactComponent as Disconnect } from '../../assets/iconset/disconnect.svg'
import { ReactComponent as Discord } from '../../assets/iconset/discord.svg'
import { ReactComponent as FaqQuestionDecoration } from '../../assets/iconset/faq-question-decoration.svg'
import { ReactComponent as Faqs } from '../../assets/iconset/faqs.svg'
import { ReactComponent as Github } from '../../assets/iconset/github.svg'
import { ReactComponent as History } from '../../assets/iconset/history.svg'
import { ReactComponent as Medium } from '../../assets/iconset/medium.svg'
import { ReactComponent as NewTab } from '../../assets/iconset/new-tab.svg'
import { ReactComponent as Night } from '../../assets/iconset/night.svg'
import { ReactComponent as QuestionCircle } from '../../assets/iconset/question-circle.svg'
import { ReactComponent as Telegram } from '../../assets/iconset/telegram.svg'
import { ReactComponent as Timer } from '../../assets/iconset/timer.svg'
import { ReactComponent as TriangleDown } from '../../assets/iconset/triangle-down.svg'
import { ReactComponent as TriangleUp } from '../../assets/iconset/triangle-up.svg'
import { ReactComponent as Twitter } from '../../assets/iconset/twitter.svg'
import { ReactComponent as Warning } from '../../assets/iconset/warning.svg'
import { Color } from '../../types/theme'

const ICON_MAP = {
  faqs: <Faqs />,
  'faq-question-decoration': <FaqQuestionDecoration />,
  'question-circle': <QuestionCircle />,
  'caret-right-circle': <CaretRightCircle />,
  'caret-right': <CaretRight />,
  close: <Close />,
  copy: <Copy />,
  coupon: <Coupon />,
  'currency-dollar': <CurrencyDollar />,
  day: <Day />,
  disconnect: <Disconnect />,
  discord: <Discord />,
  github: <Github />,
  history: <History />,
  medium: <Medium />,
  'new-tab': <NewTab />,
  night: <Night />,
  telegram: <Telegram />,
  timer: <Timer />,
  'triangle-down': <TriangleDown />,
  'triangle-up': <TriangleUp />,
  twitter: <Twitter />,
  warning: <Warning />
}

type Props = {
  className?: string
  color: Color
  icon: keyof typeof ICON_MAP
  size?: number
}

const Icon = ({ className, color = '#000', icon, size = 16 }: Props) => {
  return (
    <StyledIcon className={className} $fill={color} $size={size}>
      {ICON_MAP[icon]}
    </StyledIcon>
  )
}

export default Icon

const StyledIcon = styled.i<{
  $fill: Color
  $size: number
}>`
  display: inline-flex;
  width: ${({ $size }) => pxToVw($size)};
  height: ${({ $size }) => pxToVw($size)};

  > svg {
    width: 100%;
    height: 100%;
    fill: ${({ $fill }) => $fill};
  }

  ${({ theme, $size }) => css`
    ${theme.mediaQuery.mobile`
      width: ${pxToVw($size, 720)};
      height: ${pxToVw($size, 720)};
    `}
  `}
`
